import { useEffect, useState } from "react";
import { PagingData } from "constant/PagingData";

function useTableData(isFirstSearch, countPerPage) {
  let fnSearch;

  const [error, setError] = useState(false);
  const [isInitSearch, setInitSearch] = useState(isFirstSearch);
  const [data, setData] = useState(null);
  const [pagingInfo, setPagingInfo] = useState(null);
  // 조회 확장 정보
  const [extendData, setExtendData] = useState({
    pagingData: {
      page: 1,
      countPerPage: countPerPage ? countPerPage : PagingData.defaultCountPerPage,
    },
    sortNm: "",
  });

  const onSearchFunc = (f) => {
    fnSearch = f;
  };

  const onSortClick = (lSortData) => {
    setExtendData((prevData) => ({ ...prevData, sortNm: lSortData }));
  };

  const morePage = (countPerPaged = "32", isSearch = true) => {
    if (!isSearch) {
      setInitSearch(false);
    }

    setExtendData((prevData) => ({
      ...prevData,
      pagingData: { ...prevData.pagingData, countPerPage: countPerPaged },
    }));
  };

  const onPageChange = (page, isSearch = true) => {
    if (!isSearch) {
      setInitSearch(false);
    }

    setExtendData((prevData) => ({
      ...prevData,
      pagingData: { ...prevData.pagingData, page },
    }));
  };

  const getPagingDataToUri = () => {
    return (
      "page=" +
      extendData.pagingData.page +
      "&countPrePage=" +
      extendData.pagingData.countPerPage +
      "&sortNm=" +
      extendData.sortNm
    );
  };

  function handleChange(e, status) {
    if (status) {
      if (status.name === "countPerPage") {
        setExtendData((prev) => ({
          ...prev,
          pagingData: {
            ...prev.pagingData,
            countPerPage: e.value,
          },
        }));
      }
    }
  }

  useEffect(() => {
    if (isInitSearch && fnSearch) {
      
      fnSearch(false);
    }
    setInitSearch(true);
  }, [extendData]);

  return {
    data,
    error,

    pagingInfo,
    extendData,

    setData,

    setError,

    setPagingInfo,
    setExtendData,
    getPagingDataToUri,
    morePage,
    onSortClick,
    onPageChange,
    onSearchFunc,
    onChange: handleChange,
  };
}

export default useTableData;
